import React from 'react';
import { SvgIcon } from '../Icon';
import toastMessage from '../../utils/toastMessage';
import styled from 'styled-components';
import { useAnalytics } from '../../utils/analytics/useAnalytics';
import { buttonClicked } from '../../utils/analytics/events/button/events';
import copyTextToClipboard from '../../utils/copyTextToClipboard';
import { PrimaryButton } from '../Button';
import KubitTooltip from '../KubitTooltip';

interface IProps {
  dashboardLink: string;
}

const StyledPrimaryButton = styled(PrimaryButton)`
  display: flex;
  align-items: center;
  width: 100%;
  min-width: unset;
  height: 100%;
  padding: 0;
  border: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
`;

const CopyDashboardLink = ({ dashboardLink }: IProps) => {
  const { track } = useAnalytics();

  const handleCopyDashboardLink = async () => {
    await copyTextToClipboard(dashboardLink);

    track(buttonClicked({ context: 'dashboards', action: 'copy_link' }));

    toastMessage({
      message: `Dashboard Link Copied!`,
      type: 'info',
    });
  };

  return (
    <KubitTooltip content={'Copy URL'} placement="top-start" noOpenDelay={true}>
      <StyledPrimaryButton type="button" onClick={handleCopyDashboardLink}>
        <SvgIcon
          name="link-regular"
          width={16}
          height={16}
          customFill="currentColor"
        />
      </StyledPrimaryButton>
    </KubitTooltip>
  );
};

export default CopyDashboardLink;
